import styled from 'styled-components';

import FormFlex from '../Flex';

export default styled(FormFlex)`
  max-width: 43rem;
`;
